import type { ReactNode } from 'react';
import { SensePermis } from '@/pages/EstatsPagina';
import { useMe } from './MeContext';
import { compleix, type RequisitPermis } from './permisos';

export function RequirePermis({
  permis,
  children,
}: {
  permis?: RequisitPermis;
  children: ReactNode;
}) {
  const { me } = useMe();
  return <>{compleix(me, permis) ? children : <SensePermis />}</>;
}
